<script setup>

import {mdiClose} from "@mdi/js";

defineProps({
    header: String
})

const emit = defineEmits('closeDialog')
</script>

<template>
    <v-card
        rounded="lg"
    >
        <v-card-title class="overflow-visible d-flex align-center justify-space-between ga-2 py-3 px-0 pr-2 py-md-5 px-md-4">
            <div class="font-weight-black text-body-1 text-md-h5 pl-4 text-wrap-whole-words">
                {{header}}
            </div>
            <v-btn
                :icon="mdiClose"
                variant="plain"
                size="x-small"
                class="text-body-1"
                color="grey"
                @click="emit('closeDialog')"
            ></v-btn>
        </v-card-title>
        <v-divider color="grey-lighten-2 opacity-100"></v-divider>
        <v-card-text class=" pt-2 pt-md-8 py-md-8 px-md-8">
        <slot></slot>
        </v-card-text>
        <slot name="buttons"></slot>
    </v-card>
</template>

<style scoped lang="scss">

</style>
